import Vue from "vue";
import VueI18n from "vue-i18n";
import deMessages from "@/i18n/de";

Vue.use(VueI18n);

export default new VueI18n({
  locale: "de",
  fallbackLocale: "de",
  messages: {
    de: deMessages
  }
});
